import { SystemAdminUserInput, User } from '../../lib/types/models/users/user'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateUser({ id, ...rest }: UpdateInput<SystemAdminUserInput>) {
  return restApiClient
    .url(constructApiUrl(API.user.update.url, { id }))
    .patch<User, Partial<SystemAdminUserInput>>(rest)
}
